import Bean from './Bean';

export default class FlightDetail extends Bean {

}